import { Badge } from '@/components/ui/badge';
import { Loader2 } from 'lucide-react';

const LoadingFallback = () => {
  return (
    <>
      <div className="absolute inset-3 bg-white">
        <div className="flex flex-col items-center justify-center">
          <Badge className="flex items-center gap-1 text-sm font-medium text-gray-900 bg-white border border-gray-300 rounded-4xl shadow-md">
            <Loader2 className="h-3 w-3 animate-spin" />
            Loading
          </Badge>
        </div>
      </div>
    </>
  );
};

export default LoadingFallback;
